<template>
    <b-modal id="maintenanceModal" title="Maintenance">
        <div slot="modal-header" class="mh">
            <div>
                <h1>
                    <span>Maintenance</span>
                </h1>
            </div>
            <button id="mh-close" class="btn-close" @click="hideModal()"><i class="fas fa-times"></i></button>
        </div>

        <div>
            <p>Dear Clients,</p>

            <p>We hope this message finds you well.</p>

            <p>As part of our ongoing efforts to enhance system performance and reliability, we have scheduled a planned
                maintenance window for our systems.</p>

            <p><strong>Maintenance Details:</strong></p>
            <ul>
                <li><strong>Date:</strong> Friday, 29th December 2023</li>
                <li><strong>Time:</strong> 10:00 AM to 12:00 PM</li>
            </ul>

            <p><strong>Expected Impact:</strong> During this period, access to our systems may be temporarily unavailable.
                We understand the inconvenience this may cause and apologize for any disruption to your workflow.</p>

            <p><strong>Why the Maintenance is Necessary:</strong> This maintenance is crucial for implementing updates and
                improvements that will ensure the continued smooth operation of our systems, providing you with the best
                possible user experience.</p>

            <p><strong>How You Can Prepare:</strong> We recommend that you save any ongoing work and log out of the system
                before the maintenance window begins. Please plan accordingly for any time-sensitive tasks.</p>

            <p>We appreciate your understanding and cooperation as we work to enhance our systems. If you have any questions
                or concerns regarding this maintenance, feel free to contact our support team at
                <span v-if="crmType === 'payroll'"><a href="mailto:it@geniusmoney.co.uk">it@geniusmoney.co.uk</a></span>
                <span v-else><a href="mailto:it@v3recruitment.com">it@v3recruitment.com</a></span>
            </p>

            <p>Thank you for your continued support.</p>

            <p>Best regards,<br>{{ crmType === 'payroll' ? 'Genius Money' : 'V3' }} Team</p>
        </div>

        <template v-slot:modal-footer="{ cancel, ok }">
            <button type="button" class="btn orcaBtn" @click="onOk">I understand</button>
        </template>
    </b-modal>
</template>
  
<script>

import VueCookies from 'vue-cookie';

export default {
    data() {
        return {
            maintenanceAcknowledged: VueCookies.get('maintenanceAcknowledged'),
        };
    },
    watch: {
        maintenanceAcknowledged() {
            this.maintenanceAcknowledged = VueCookies.get('maintenanceAcknowledged');
        },
    },
    methods: {
        onOk() {
            VueCookies.set('maintenanceAcknowledged', 'true', { expires: '2h' });
            this.$bvModal.hide('maintenanceModal');
        },
        hideModal() {
            this.$bvModal.hide('maintenanceModal');
        },
    },
    mounted() {
        const maintenanceAcknowledged = VueCookies.get('maintenanceAcknowledged');
        if (!maintenanceAcknowledged) {
            this.$bvModal.show('maintenanceModal');
        }
    },
};
</script>
